import { render } from "./CreateReportEvent.vue?vue&type=template&id=17590143"
import script from "./CreateReportEvent.vue?vue&type=script&lang=js"
export * from "./CreateReportEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__